import { useTracker } from '@lichtblick/tracker';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { createFailureEvent, createSuccessEvent } from './b2b-funnel-embed.tracking';
export const useSuccessOrFailureHandling = (funnelState)=>{
    const { trackCustomEvent } = useTracker();
    const { push } = useRouter();
    useEffect(()=>{
        if (!funnelState.submitStatus) {
            return;
        }
        if (funnelState.submitStatus === 'error') {
            const failureEvent = createFailureEvent(funnelState);
            trackCustomEvent(failureEvent);
            return;
        }
        const redirectURL = '/gewerbe-photovoltaik-danke/';
        const successEvent = createSuccessEvent(funnelState);
        trackCustomEvent(successEvent);
        push(redirectURL);
    }, [
        funnelState,
        push,
        trackCustomEvent
    ]);
};

//# sourceMappingURL=b2b-funnel-embed.helpers.js.map